
export default class ApplicationView
{
  constructor()
  {
    this.name = undefined;
    this.container = undefined;
  }

  start(name, container)
  {
    this.name = name;
    this.container = container;
  }

  update()
  {
  }

  on_resize()
  {
  }

  show()
  {
  }

  hide()
  {
  }
}
